import logo from "@/assets/logo.png"

type LoadingProps = {
    overlay?: boolean
}

export function Loading({ overlay = false }: LoadingProps) {
    return (
        <div
            className={
                overlay
                    ? "fixed inset-0 z-layer-modal-content flex min-h-dvh w-screen items-center justify-center bg-background px-4 py-6 sm:px-6 md:px-8 lg:px-10 xl:px-12 2xl:px-16"
                    : "flex min-h-dvh w-full items-center justify-center bg-background px-4 py-6 sm:px-6 md:px-8 lg:px-10 xl:px-12 2xl:px-16"
            }
            role="status"
            aria-live="polite"
        >
            <div className="mx-auto flex w-full max-w-xs flex-col items-center justify-center gap-4 text-center sm:max-w-sm sm:gap-5 md:max-w-md lg:max-w-lg lg:gap-6 xl:max-w-xl 2xl:max-w-2xl">
                <div className="relative flex h-32 w-32 shrink-0 items-center justify-center rounded-full bg-card shadow-lg ring-1 ring-border sm:h-36 sm:w-36 md:h-40 md:w-40 lg:h-44 lg:w-44 xl:h-48 xl:w-48 2xl:h-52 2xl:w-52">
                    <div className="absolute inset-0 rounded-full border-4 border-muted border-t-accent animate-spin md:border-8" />
                    <div className="absolute inset-3 rounded-full border border-border bg-background shadow-inner sm:inset-4 md:inset-5" />
                    <div className="relative z-10 flex h-20 w-20 items-center justify-center rounded-full bg-card p-2 shadow-sm ring-1 ring-border sm:h-24 sm:w-24 md:h-28 md:w-28 lg:h-32 lg:w-32 xl:h-36 xl:w-36 2xl:h-40 2xl:w-40">
                        <img
                            src={logo}
                            alt="SpareLynk Logo"
                            width={128}
                            height={128}
                            decoding="async"
                            fetchPriority="high"
                            className="h-full w-full object-contain"
                        />
                    </div>
                </div>

                <div className="w-full space-y-1.5 sm:space-y-2 md:space-y-3">
                    <h1 className="text-lg font-semibold leading-tight text-foreground sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl">
                        Loading SpareLynk
                    </h1>
                    <p className="mx-auto max-w-xs text-xs leading-relaxed text-muted-foreground sm:max-w-sm sm:text-sm md:max-w-md md:text-base lg:max-w-lg lg:text-lg">
                        Please wait while we prepare your page.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Loading
